/**
 * Formats a date as "DD MMM YYYY"
 * @param date - Date object, timestamp (number), or null/undefined
 * @returns Formatted date string or empty string for null/undefined
 */
export const formatDate = (date: Date | number | null | undefined): string => {
  if (!date) return '';

  const dateObj = typeof date === 'number' ? new Date(date * 1000) : new Date(date);

  if (isNaN(dateObj.getTime())) return '';

  const monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const day = dateObj.getDate();
  const month = monthAbbreviations[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day} ${month} ${year}`;
};
